import {
	KDataTable,
	KDataTableMenu,
	KPdfDialog
} from "kinnect-general";
import {
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";
import { formatDate, formatTime } from "kinnect-formatters";

export default KDataTable.extend( {
	name: "KNearMissReportsTable",

	props: {
		noDataText: {
			...KDataTable.options.props.noDataText,
			default: "There are no reports to display"
		},

		noResultsText: {
			...KDataTable.options.props.noResultsText,
			default: "No matching reports found"
		},

		sortBy: {
			...KDataTable.options.props.sortBy,
			default: "created_at"
		},

		sortDesc: {
			...KDataTable.options.props.sortDesc,
			default: true
		}
	},

	computed: {
		defaultHeaders() {
			return [
				{
					text: "Date of Report",
					value: "created_at"
				},
				{
					text: "Completed",
					value: "completed"
				},
				{
					text: "Employee(s) Involved",
					value: "employeesInvolvedNames"
				},
				{
					text: "Report Type",
					value: "reportType.name"
				},
				{
					text: "Incident Date",
					value: "incidentDate"
				},
				{
					text: "Incident Time",
					value: "incidentTime"
				},
				{
					align: "end",
					sortable: false,
					text: this.isMobile ? "Actions" : "",
					value: "actions"
				}
			];
		}
	},

	render() {
		return <KDataTable
			attrs={this.$props}
			headers={this.$_headers}
			on={{ ...this.$listeners }}
			scopedSlots={{
				"item.created_at": ( { item } ) => formatDate( item.created_at ),

				"item.completed": ( { item } ) => (
					item.completed
						? <VIcon class="success--text">done</VIcon>
						: <VIcon class="error--text">clear</VIcon>
				),

				"item.incidentDate": ( { item } ) => formatDate( item.incidentDate ),

				"item.incidentTime": ( { item } ) => formatTime( item.incidentTime ),

				"item.actions": ( { item } ) =>
					<KDataTableMenu>
						<VList>
							<VListItem to={{
								name: "safetyNearMiss",
								params: { idReport: item.id }
							}}>
								<VListItemAction>
									<VIcon>visibility</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>View</VListItemTitle>
								</VListItemContent>
							</VListItem>

							<KPdfDialog
								scopedSlots={{
									activator: ( { on } ) =>
										<VListItem on={on}>
											<VListItemAction>
												<VIcon>picture_as_pdf</VIcon>
											</VListItemAction>

											<VListItemContent>
												<VListItemTitle>
													Printable PDF
												</VListItemTitle>
											</VListItemContent>
										</VListItem>
								}}
								src={`safety/near-miss-reports/${item.id}`}
								title="Near Miss Report"
							></KPdfDialog>
						</VList>
					</KDataTableMenu>,

				...this.$scopedSlots
			} }
		></KDataTable>;
	}
} );
